/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function (Tc, $) {
	'use strict';

	/*
	 * Dependencies:
	 * TerrificJs 2.0.1,
	 * jQuery 1.6.4 or greater
	 */

	/**
	 * Expandable Container
	 *
	 * @author Dimitri Sebeschuk, Marc Althoff
	 * @namespace Tc.Module
	 * @class ExpandableContainer
	 * @extends Tc.Module
	 */
	Tc.Module.ExpandableContainer = Tc.Module.extend({

		on: function (callback) {
			var mod = this;
			this.hashKey = 'expandableContainer-' + this.$ctx.data('id');

			mod.isEditMode = window.CQ && window.CQ.WCM && window.CQ.WCM.isEditMode(true);
			mod.$expandable = mod.$ctx.find('.expandable').eq(0);
			mod.$button = mod.$ctx.find('.expandableButton').eq(0);

			// Make sure the background container does not show a scroll bar when we’re expanding
			mod.$ctx.closest('.modBackgroundContainer').css('overflow', 'hidden');

			if (!mod.isEditMode) {
				mod.$ctx.on('click', '.expandableButton, .sdxClose', $.proxy(mod.handleExpand, mod));
			}
			callback();
		},

		after: function (hashState) {
			if(!jQuery.isEmptyObject(hashState)) {
				this.moduleStateChanged(hashState);
			} else if (this.$ctx.data('start-open')) {
				this.setState();
			}
		},

		handleExpand: function (e) {
			var mod = this;
			e.stopPropagation();
			mod.$ctx.toggleClass('expanded');
			this.setState();
			if (mod.$ctx.hasClass('sdxtheme')) {
				var containerID = mod.$ctx.data('id') || 'expandable-container',
					status = '';
				if (mod.$ctx.hasClass('expanded')) {
					status = 'open';
					$('html, body').animate({
						scrollTop: mod.$ctx.find('.expandable').offset().top - 100
					}, 1000);
				}
				else {
					status = 'close';
				}
				SCS.portal.datalayer.trackEvent(status, containerID, utag_data.page_cfu + '/' + utag_data.page_language + '/' + utag_data.page_path, 'expandable-container');
			}
		},

		moduleStateChanged: function (hashState) {
			var mod = this;
			this.$ctx.toggleClass('expanded', !!hashState[this.hashKey]);
		},

		setState: function() {
			var state = {};
			state[this.hashKey] = this.$ctx.hasClass('expanded') ? 'expanded' : '';
			this.setModuleState(state);
		}
	});
}(window.Tc, window.Tc.$));

}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.ExpandableContainer.js
// module id = 141
// module chunks = 0